import { Button, Typography } from '@braskai/ui-kit';
import { useNavigate } from 'react-router-dom';

import { CardMedia, Stack } from '@mui/material';

import NotFoundImage from '@/shared/assets/images/404.png';
import { PATHS } from '@/shared/constants/routes/paths';

export const NotFoundError = () => {
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" gap={20} justifyContent="center" minHeight="100%">
      <CardMedia
        sx={{
          height: 136,
          width: 234,
        }}
        alt="404"
        component="img"
        src={NotFoundImage}
      />
      <Stack gap={4} textAlign="center">
        <Typography color="grey.900" variant="title-3-md">
          Page not found
        </Typography>

        <Typography color="grey.500" variant="body-1">
          The page you are looking for doesn’t exist.
        </Typography>
      </Stack>

      <Button size="lg" onClick={() => navigate(PATHS.homepage)}>
        Go home
      </Button>
    </Stack>
  );
};
